import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'
import RenderValidateMessage from '../Validation/RenderValidateMessage';

export default function SelectInput(props) {
    const { label, errors, options, setValue, value, valueName, placeholder, required = false } = props;

    const selected = options.find((option) => {
        return option.value === value
    });

    return (
        <Form.Group>
            <Form.Label>{required && <span className="text-danger">*</span>} {label}</Form.Label>
            <Select
                options={options}
                placeholder={placeholder}
                onChange={e => setValue({ [valueName]: e.value })}
                value={selected || ''}
            />
            <RenderValidateMessage errors={errors} field={valueName} />
        </Form.Group>
    )
}
